export const PaycardTransactionType = {
  PAYMENT: "payment",
  WITHDRAWAL: "withdrawal",
  REFUND: "refund",
  RETURN: "return",
} as const;

export type PaycardTransactionType =
  (typeof PaycardTransactionType)[keyof typeof PaycardTransactionType];
